/**
 * Splits emoji from the beginning of text.
 * Returns a tuple of [emoji | null, remaining text].
 *
 * @param text - The text to split
 * @returns A tuple containing the emoji (or null) and the remaining text
 *
 * @example
 * splitEmoji('🔍 Searching files') // ['🔍', 'Searching files']
 * splitEmoji('No emoji here') // [null, 'No emoji here']
 */
export function splitEmoji(text: string): [string | null, string] {
  const match = /^(\p{Emoji_Presentation}|\p{Extended_Pictographic})\s*/u.exec(
    text,
  );

  if (match) {
    const emoji = match[1];
    const rest = text.slice(match[0].length).trim();
    return [emoji, rest];
  }

  return [null, text.trim()];
}
